import { type ReactNode } from 'react';
import {
  Button,
  Dialog,
  Modal as AriaModal,
  ModalOverlay,
} from 'react-aria-components';
import { MdClose } from 'react-icons/md';

import ModalResize from '@/ui/modal/components/modal-resize';

import styles from './modal.module.scss';

interface ModalProps {
  children: ReactNode,
  isCloseOnClickOutside?: boolean,
  showCloseIcon?: boolean,
  isOpen?: boolean,
  onOpenChange?: (isOpen: boolean) => void,
}

export default function Modal(props: ModalProps) {
  const {
    children,
    isCloseOnClickOutside = false,
    isOpen,
    onOpenChange,
    showCloseIcon = false,
  } = props;

  return (
    <ModalOverlay className={styles.modalOverlay} isDismissable={isCloseOnClickOutside}>
      <AriaModal onOpenChange={onOpenChange} isOpen={isOpen} isKeyboardDismissDisabled className={styles.ariaModal}>
        <Dialog>
          <ModalResize>
            <div className={styles.modal}>
              {showCloseIcon && (
                <Button slot="close" className={styles.modal_closeButton}>
                  <MdClose className={styles.modal_closeIcon} />
                </Button>
              )}

              {children}
            </div>
          </ModalResize>
        </Dialog>
      </AriaModal>
    </ModalOverlay>
  );
}
